import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Logo from '../../images/pngs/Logo.png';
import { FaCheckCircle, FaTimesCircle, FaSignInAlt } from 'react-icons/fa';
import SEO from '../../Components/utils/SEO';

export default function EmailVerified() {
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');
  const isSuccess = !error;

  return (
    <div className="emailVerifiedPage">
      <SEO title="Email verification" description="Email verification status for your Chocowi account." noIndex noFollow />
      <div className={`emailVerifiedCard ${isSuccess ? 'success' : 'error'}`}>
        <div className="emailVerifiedIconWrap">
          {isSuccess ? (
            <FaCheckCircle className="emailVerifiedIcon success" />
          ) : (
            <FaTimesCircle className="emailVerifiedIcon error" />
          )}
        </div>
        <img src={Logo} alt="Chocowi" className="emailVerifiedLogo" />
        <h1 className="emailVerifiedTitle">
          {isSuccess ? 'Email Verified!' : 'Verification Failed'}
        </h1>
        <p className="emailVerifiedDescription">
          {isSuccess
            ? 'Your email has been successfully verified. You can now log in to your account and start exploring.'
            : error === 'expired'
              ? 'This verification link has expired. Please request a new verification email from your account settings.'
              : 'This verification link is invalid or has already been used. Please try logging in or request a new verification email.'}
        </p>
        <Link to="/signin" className="emailVerifiedBtn">
          <FaSignInAlt size={18} /> Log In
        </Link>
      </div>
    </div>
  );
}
